import { useUIState } from "@bcm-dev/bcms-vite";
import UINotifiButton from "components/shared/notifi/UINotifiButton";
import UINotifiDayPicker from "components/shared/notifi/UINotifiDayPicker";
import UINotifiTimePicker from "components/shared/notifi/UINotifiTimePicker";
import UINotifiToggle from "components/shared/notifi/UINotifiToggle";
import "./styles.css";
import "./mobile.css";


// Returns an object that will be used to merge with the parent "ui" object.
export const getQuietTimesWidgetConfig = () => ({ action: "", toggle: { isActive: false }});

export default function QuietTimesWidget(props) {
    const contactType = props.contactType ?? "[contactType]";
    const quietTime = props.quietTime ?? {};
    const setTimeOfDayIsValid = props.setTimeOfDayIsValid ?? (() => {});
    const updateQuietTime = props.updateQuietTime ?? (() => {});
    const updateQuietTimeScheduledTime = props.updateQuietTimeScheduledTime ?? (() => {});
    const updateScheduledTimeWeekdays = props.updateScheduledTimeWeekdays ?? (() => {});
    const quietTimeIsValid = setTimeOfDayIsValid(quietTime.id);
    const onSaveClick = props.onSaveClick ?? (() => {});
    const canUpdateQuietTime = props.canUpdateQuietTime ?? (() => {});
    const quietTimeIsEnabledGlobally = props.quietTimeIsEnabledGlobally ?? (() => {});
    const { key, config } = useUIState(`QuietTime_${ quietTime.id }`, getQuietTimesWidgetConfig());

    return (
        <div className="quiet-times-widget flex-width">
            <p className="header-text"><span data-point={ `QuietTime_Header_${ quietTime.id }`}>Quiet Times</span></p>
            <div className="flex-container flex-horizontal align-center contact-type-container">
                <div className="flex-width">
                    <span className="contact-type-text">{contactType}</span>
                </div>
                <div className="flex-width flex-container align-center justify-right">
                    <UINotifiToggle value={ quietTime.isEnabled } onChange={ updateQuietTime(quietTime.id, "isEnabled", key) } />
                    <span>Do not disturb</span>
                </div>
            </div>
            {/* Setting the "disabled" class to this container disable the QuietTimesWidget content*/}
            <div className={ `quiet-times-widget-container ${quietTime.isEnabled ? "" : "disabled" }`}>
                <div className="start-end-time-container">
                    <div className="flex-container flex-horizontal align-center start-time-container time-container">
                        <div className="set-width">
                            <span>Start time:</span>
                        </div>
                        <UINotifiTimePicker alertDetail={ quietTime } type="start" scheduledTime={ quietTime.startScheduledTime } 
                        updateTimeOfDay={ updateQuietTimeScheduledTime }
                         className="flex-width justify-right" />
                    </div>
                    <div className="flex-container flex-horizontal align-center end-time-container time-container">
                        <div className="set-width">
                            <span>End time:</span>
                        </div>
                        <UINotifiTimePicker alertDetail={ quietTime } type="end" scheduledTime={ quietTime.endScheduledTime } 
                        updateTimeOfDay={ updateQuietTimeScheduledTime }
                        className="flex-width justify-right" />
                    </div>
                </div>
                <UINotifiDayPicker alertDetail={ quietTime } scheduledAlert={ quietTime } 
                updateScheduledTimeWeekdays={ updateScheduledTimeWeekdays } className="justify-center" />
            </div>
            { !quietTimeIsEnabledGlobally(quietTime.id) && 
            <div className="flex-container flex-horizontal align-center button-container">
                <UINotifiButton className={ quietTimeIsValid ? "" : "disabled" } 
                text="Save" onClick={ onSaveClick(quietTime.id, "save", key) } />
            </div>
            }
            { quietTimeIsEnabledGlobally(quietTime.id) && 
            <div className="flex-container flex-horizontal align-center button-container">
                <UINotifiButton className={ canUpdateQuietTime(quietTime.id) ? "" : "disabled" } 
                text="Update" onClick={ onSaveClick(quietTime.id, "update", key) } />
            </div>
            }
            {/* should be shown when "save" is clicked */}
            { config.action === "saved" && 
            <p className="successful created-text">Quiet Time Created.</p>
            }
            {/* should be shown when toggle is clicked to disable again */}
            { config.action === "deleted" && 
            <p className="successful deleted-text">Quiet Time Deleted.</p>
            }
            { config.action === "updated" && 
            <p className="successful deleted-text">Quiet Time Updated.</p>
            }
        </div>
    )
}